import yousers from '@yola/yousersjs';
import get from 'lodash.get';
import configStorage from '../../configuration/config-storage';

let serviceClient;

export default {
  get(isB2C = true) {
    if (!serviceClient) {
      const { commonConfig } = configStorage.get();
      const apiUrl = get(commonConfig, `public-api-gateway.${isB2C ? 'url' : 'wl_url'}`, '');

      serviceClient = {
        ...yousers.setAPIRoot(apiUrl),
      };
    }

    return serviceClient;
  },
};
